import { render, staticRenderFns } from "./form-warning.vue?vue&type=template&id=096dbdc6&scoped=true&"
import script from "./form-warning.vue?vue&type=script&lang=js&"
export * from "./form-warning.vue?vue&type=script&lang=js&"
import style0 from "./form-warning.vue?vue&type=style&index=0&id=096dbdc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096dbdc6",
  null
  
)

export default component.exports